<template>
  <section class="follow-section">
    <div class="container">
        <div class="follow-container">
            <div class="follow-image">
                <img src="@/assets/images/Group 9.png" alt="Mr Ahmed" class="person" />
            </div>
            <div class="follow-text">
                <p class="sub-title">عايز تتابع السوشيال ميديا</p>
                <h2 class="title">
                تابع أكتر عالم <br />
                <span class="highlight">مستر أحمد </span><span class="hero-subtext">مكاوي</span>
                </h2>
                <p class="desc">
يمكنك الوصول إلى جميع منصات مستر أحمد مكاوي بسهولة.
امسح رمز الـ QR أو اضغط على الزر أدناه لتصفح المحتوى الكامل من فيديوهات، قنوات، وروابط هامة – كلها في مكان واحد.                </p>
                <a href="https://linktr.ee/ahmedmekawy93" class="follow-btn"> 
                    تابع الآن  
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                    </svg>
                </a>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FollowUsSection",
};
</script>

<style>
.follow-section {
  background: #EFF1F4;
  padding: 224px 0px;
  position: relative;
  z-index: 1;
}

.follow-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.follow-text {
  display: flex;
  flex-direction: column;
   align-items: flex-start;
  gap: 24px;
  width: 50%;
}

.sub-title {
  color: #FF9A18;
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: 400;
}

.title {
  font-size: 54px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #000;
  line-height: 1.5;
}

.highlight {
  color: #000;
}

.desc {
  font-size: 22px;
  line-height: 1.7;
  color: #7F8685;
  margin-bottom: 25px;
  font-weight: 400;
}

.follow-btn {
  background: #ff7b00;
  color: #fff;
  border: none;
  padding: 13px 24px;
  border-radius: 30px;
  font-size: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: 0.3s;
}
.follow-btn svg {
  animation: arrowMove 1s infinite alternate ease-in-out;
}

@keyframes arrowMove {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-6px);
  }
}

.follow-btn:hover {
  background: #e56a00;
}

.follow-image {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50%;
}

.person {
  width: 100%;
  max-width: 600px;
  border-radius: 20px;
}

@media (max-width: 768px) {
    .follow-section {
        padding: 100px 0px;
    }
  .follow-container {
    flex-direction: column;
    text-align: center;
  }
.follow-text {
    align-items: center;
}
.follow-image {
    width: 100%;
    }
.follow-text {
    width: 100%;
}
.desc {
    font-size: 18px;
}
}
</style>
